export function getLogPageScrollerV115(table) {
  for (
    let parent = table?.parentElement;
    parent && parent !== document.documentElement;
    parent = parent.parentElement
  ) {
    // With visible root overflow, body overflow is propagated to the viewport.
    const rootStyle = getComputedStyle(document.documentElement);
    if (
      parent === document.body &&
      (!rootStyle.overflowX || rootStyle.overflowX === 'visible') &&
      (!rootStyle.overflowY || rootStyle.overflowY === 'visible')
    ) {
      continue;
    }
    if (
      /^(auto|scroll)$/.test(getComputedStyle(parent).overflowY) &&
      parent.scrollHeight > parent.clientHeight
    ) {
      return parent;
    }
  }
  return window;
}

export function getLogPageOffsetV115(element, scroller) {
  const top = element.getBoundingClientRect().top;
  return scroller === window
    ? top + window.scrollY
    : top - scroller.getBoundingClientRect().top - scroller.clientTop +
        scroller.scrollTop;
}
